import { IRadioOption, ISelectOption } from 'shell-models-lib';

export const variableTypeOptions: Array<ISelectOption<string | undefined>> = [
    {
        label: stringResources.Variable_String,
        value: 'String'
    },
    {
        label: stringResources.Variable_Boolean,
        value: 'Boolean'
    },
    {
        label: stringResources.Variable_Array,
        value: 'Array'
    },
    {
        label: stringResources.DataFlowColumnType_Integer,
        value: 'Integer'
    }
];

export const snowflakeVersioning: Array<IRadioOption<string>> = [
    {
        label: '1.1',
        value: '1.1'
    },
    {
        label: '1.0',
        value: undefined
    }
];